import jsqr from "jsqr"
import { QrPaymentUrlParams } from "../api/interface"
import { ROUTES_PATHS } from "./constants"

/** Returns qrcId from `/qr/:qrcId`, or undefined for `/qr`. */
export const getQrcIdFromPath = (pathname: string) => {
  const [route, qrcId] = pathname.split("/").filter(Boolean)
  return route === ROUTES_PATHS.qr ? qrcId : undefined
}

export const parseQrPaymentUrl = (url: string): QrPaymentUrlParams | null => {
  try {
    const parsedUrl = new URL(url)
    const [qrcId] = parsedUrl.pathname.split("/").filter(Boolean)

    if (!qrcId) {
      return null
    }

    return {
      host: parsedUrl.host,
      qrcId,
      type: parsedUrl.searchParams.get("type"),
      memberId: parsedUrl.searchParams.get("bank"),
      sum: parsedUrl.searchParams.get("sum"),
      cur: parsedUrl.searchParams.get("cur"),
      crc: parsedUrl.searchParams.get("crc"),
    }
  } catch {
    return null
  }
}

export const decodeQrFromImageSrc = (imageSrc: string): Promise<string | null> =>
  new Promise((resolve) => {
    const image = new Image()
    image.onload = () => {
      const canvas = document.createElement("canvas")
      canvas.width = image.width
      canvas.height = image.height

      const context = canvas.getContext("2d")
      if (!context) {
        resolve(null)
        return
      }

      context.drawImage(image, 0, 0)
      const imageData = context.getImageData(0, 0, canvas.width, canvas.height)
      const qr = jsqr(imageData.data, imageData.width, imageData.height)
      resolve(qr?.data ?? null)
    }
    image.onerror = () => resolve(null)
    image.src = imageSrc
  })
